/**
 * E3. Слоты: ставка ползунком до всех сбережений, «Крутить» и «Крутить ×10».
 * Под кнопкой автоповтора написано честно: тяга растёт вдвое быстрее.
 * Таблица выплат — из констант логики. Барабаны «крутятся» 1,5 с,
 * пропускается; при «меньше движения» — сразу.
 */
import { t } from '@life/i18n';
import {
  SLOT_REEL,
  SLOTS_AUTO_SPINS,
  SLOTS_PAYOUT_THREE_SAME,
  SLOTS_PAYOUT_THREE_SEVENS,
  SLOTS_PAYOUT_TWO_SEVENS,
  SLOTS_URGE,
  SLOTS_URGE_AUTO,
  type SlotsInput,
  type SlotsState,
} from '@life/minigames';
import { useReveal } from './reveal';
import type { MinigameScreenProps } from './types';
import { Bet, betCap, useBet } from './ui/Bet';

export const SLOTS_SPIN_MS = 1500;

export function Slots({ state, life, onInput }: MinigameScreenProps<SlotsInput, SlotsState>) {
  const cap = betCap(state.maxBet, life.money);
  const [bet, setBet] = useBet(cap);
  const reveal = useReveal(SLOTS_SPIN_MS);
  const canSpin = bet > 0 && !reveal.running;

  const spin = (auto10: boolean) => {
    if (!canSpin) return;
    reveal.begin(() => onInput(auto10 ? { bet, auto10: true } : { bet }));
  };

  return (
    <>
      <p class="hint">
        {t('ui.minigame.slots.payouts', {
          sevens: SLOTS_PAYOUT_THREE_SEVENS,
          same: SLOTS_PAYOUT_THREE_SAME,
          two: SLOTS_PAYOUT_TWO_SEVENS,
          symbols: SLOT_REEL.length,
        })}
      </p>
      <Bet cap={cap} value={bet} onChange={setBet} />
      {reveal.running ? (
        <>
          <p class="hint mono">{t('ui.minigame.slots.spinning')}</p>
          <button type="button" class="btn ghost" onClick={reveal.skip}>
            {t('ui.minigame.reveal.skip')}
          </button>
        </>
      ) : (
        <div class="picks">
          <button type="button" class="btn accent" disabled={!canSpin} onClick={() => spin(false)}>
            {t('ui.minigame.slots.spin')}
          </button>
          <button type="button" class="btn" disabled={!canSpin} onClick={() => spin(true)}>
            {t('ui.minigame.slots.auto', { n: SLOTS_AUTO_SPINS })}
          </button>
        </div>
      )}
      <p class="hint">{t('ui.minigame.slots.autoWarn', { n: SLOTS_AUTO_SPINS, auto: SLOTS_URGE_AUTO, one: SLOTS_URGE })}</p>
    </>
  );
}
